import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["video", "cover"]

  connect() {
    console.log("[HeroVideoController] Connected successfully.");
    this.setupFade();
  }

  setupFade() {
    if (!this.hasVideoTarget || !this.hasCoverTarget) {
      console.log("[HeroVideoController] Missing video or cover target.");
      return;
    }

    const video = this.videoTarget;
    const cover = this.coverTarget;

    const fadeOut = () => {
      if (cover.classList.contains('opacity-0')) return; // Avoid double triggers
      console.log("[HeroVideoController] Fading out cover image...");
      cover.classList.add('opacity-0');
      setTimeout(() => {
        if (cover && cover.parentNode) {
          cover.remove();
          console.log("[HeroVideoController] Cover element removed from DOM.");
        }
      }, 700);
    };

    // 1. Race condition: If video is already playing
    if (video.currentTime > 0 && !video.paused) {
      console.log("[HeroVideoController] Video is already playing. Fading out immediately.");
      fadeOut();
      return;
    }

    // 2. Playback events
    video.addEventListener('playing', () => {
      console.log("[HeroVideoController] 'playing' event fired.");
      fadeOut();
    }, { once: true });

    video.addEventListener('canplay', () => {
      console.log("[HeroVideoController] 'canplay' event fired.");
      fadeOut();
    }, { once: true });

    // 3. User click fallback
    cover.addEventListener('click', () => {
      console.log("[HeroVideoController] Cover image clicked. Forcing play.");
      video.play().then(fadeOut).catch(err => {
        console.warn("[HeroVideoController] Force play was rejected:", err);
        fadeOut(); // force fade anyway
      });
    });

    // 4. Safety timeout fallback
    setTimeout(() => {
      if (cover && cover.parentNode && !cover.classList.contains('opacity-0')) {
        console.log("[HeroVideoController] Safety fallback timeout reached.");
        fadeOut();
      }
    }, 2500);
  }
}
